import { Backdrop } from "@mui/material";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { common_axios } from "../../../App";
import Loader from "../../../components/Loader";
import "../../../../src/assetsrewards/css/material-dashboard.css";
import moment from "moment";
import RewardsFileExampleFile from "./RewardsFileExampleFile";
import { Link } from "react-router-dom";
import file2 from "../../../../src/file/Book1.xlsx";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";

export default function Rewards() {
  const [open, setOpen] = useState(false);
  const [packType, setPackType] = useState([{}]);
  const [PackTypeId, setPackTypeId] = useState([]);
  const [ValueArray, setValueArray] = useState([]);

  const [cartCount, setcartCount] = useState([]);
  const [resllerCartList, setresllerCartList] = useState([]);

  const [getid, setgetid] = useState("");

  const customId1 = "custom-id-yess";

  const textBoxesChange = (type, value, index) => {
    if (type == true) {
      console.log(value);
      if (!getid.includes(value)) {
        setgetid([...getid, value]);
      }
    } else {
      if (getid.includes(value)) {
        const variable = getid.filter((e) => e != value);
        setgetid(variable);
      }
    }
  };
  const textBoxesChanges = (type, value, index) => {
    if (type == true) {
      setgetid(value);
    }
  };

  const addToCart = async (index) => {
    try {
      setOpen(true);

      const res = await common_axios.post(
        `http://192.168.167.66:5003/reward/v1/reseller/addToCart`,
        {
          resellerUserId: localStorage.getItem("UserId"),
          packId: getid,
          quantity: PackTypeId[index],
        }
      );

      if (res.data.statusDescription.statusCode == 200) {
        getProducts();
        setcartCount([...cartCount, getid]);

        setOpen(false);
        // setPackType(res.data.rewardProductList);
        // await setStatus("approved");
        await toast.success("Item added to cart", {
          theme: "colored",
          toastId: customId1,
          toastId: customId1,
        });
      } else {
        setOpen(false);
        await toast.error(res.data.statusDescription.description, {
          theme: "colored",
          toastId: customId1,
          toastId: customId1,
        });
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
      await toast.error("Something went wrong", {
        theme: "colored",
        toastId: customId1,
        toastId: customId1,
      });
    }
  };

  console.log(PackTypeId, "jsjsj");

  const getCards = async () => {
    try {
      setOpen(true);
      const res = await common_axios(
        `${process.env.REACT_APP_COMMON_API_REWARDS}/reward/v1/product/list/88`
      );

      if (res.data.statusDescription.statusCode == 200) {
        setOpen(false);
        setPackType(res.data.rewardProductList);
        let arrr = {};
        for (
          let index = 0;
          index < res.data.rewardProductList.length;
          index++
        ) {
          // const element = array[index];
          arrr[index] = await 1;
        }

        setPackTypeId(arrr);
        // await setStatus("approved");
        await toast.success({
          theme: "colored",
          toastId: customId1,
          toastId: customId1,
        });
      } else {
        setOpen(false);
        await toast.error(res.data.statusDescription.description, {
          theme: "colored",
          toastId: customId1,
          toastId: customId1,
        });
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
      await toast.error("Something went wrong", {
        theme: "colored",
        toastId: customId1,
        toastId: customId1,
      });
    }
  };

  const getProducts = async () => {
    try {
      setOpen(true);

      const res = await common_axios(
        `${
          process.env.REACT_APP_COMMON_API_REWARDS
        }/reward/v1/reseller/addToCart/list/${localStorage.getItem("UserId")}`
      );

      if (res.data.statusDescription.statusCode == 200) {
        setresllerCartList(res?.data?.resellerCartList);
        setOpen(false);
        // setPackType(res.data.rewardProductList);
        // await setStatus("approved");
        await toast.success({
          theme: "colored",
          toastId: customId1,
          toastId: customId1,
        });
      } else {
        setOpen(false);
        await toast.error(res.data.statusDescription.description, {
          theme: "colored",
          toastId: customId1,
          toastId: customId1,
        });
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
      await toast.error("Something went wrong", {
        theme: "colored",
        toastId: customId1,
        toastId: customId1,
      });
    }
  };

  useEffect(async () => {
    await getCards();
    await getProducts();
  }, []);

  console.log(getid, "pop");

  return (
    <>
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
          // onClick={handleClose}
        >
          <Loader />
        </Backdrop>
        <div class="container-fluid">
          {/* <h6 class="font-weight-bolder mb-4">Reward Management</h6> */}
          <div class="row">
            <div class="col-xl-12 col-sm-12 mb-xl-0 mb-4">
              <div class="card mb-3 mt-4">
                <div class="card-header p-3 pt-2">
                  <div class="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute">
                    <EmojiEventsIcon
                      sx={{ color: "white", fontSize: "33px" }}
                    />
                  </div>
                  <div class="">
                    <p
                      className="text-md text_top mb-0 text-capitalize text-start fw-bold d-inline"
                      style={{ marginLeft: "70px" }}
                    >
                      Reward Management
                    </p>
                  </div>
                </div>
                <div class="card-body">
                  <ul
                    class="nav justify-content-end nav-tabs"
                    id="myTab"
                    role="tablist"
                  >
                    {/* <li class="nav-item" role="presentation">
                      <button
                        class="nav-link active"
                        id="home-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#reseller_rewards"
                        type="button"
                        role="tab"
                        aria-controls="AccountDetails"
                        aria-selected="true"
                      >
                        Reseller
                      </button>
                    </li> */}
                    {/* <li class="nav-item" role="presentation">
                      <button
                        class="nav-link"
                        id="SenderMasking-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#SenderMasking"
                        type="button"
                        role="tab"
                        aria-controls="SenderMasking"
                        aria-selected="false"
                      >
                        Rewards
                      </button>
                    </li> */}
                    <div className="text-end position-relative">
                      <Link className="d-block" to="/dashboard/payment">
                        <ShoppingCartIcon />
                      </Link>

                      <span className="d-block position-absolute spn_ab">
                        {/* {cartCount.length
                          ? cartCount.length
                          : resllerCartList.length} */}
                        {resllerCartList?.length}
                      </span>
                    </div>
                    {/* <span className="d-block position-absolute spn_ab">
                      {cartCount.length
                        ? cartCount.length
                        : resllerCartList.length}
                    </span> */}
                  </ul>

                  <div class="tab-content" id="myTabContent">
                    <div
                      class="tab-pane fade show active"
                      id="reseller_rewards"
                      role="tabpanel"
                      aria-labelledby="reseller-tab"
                    >
                      {/* <div class="row p-4">
                        {packType?.length > 0 &&
                          packType?.map((p, index) => {
                            return (
                              <>
                                <div class="col-md-3" key={p.id}>
                                  <div
                                    class="card_234"
                                    // onClick={(e) => setgetid(e.target.value)}
                                  >
                                    <input
                                      required
                                      type="radio"
                                      name="pricing"
                                      id=""
                                      value={p.id}
                                      onChange={(e) => {
                                        console.log(
                                          e.target.checked,
                                          p.id,
                                          index
                                        );
                                        textBoxesChanges(
                                          e.target.checked,
                                          p.id,
                                          index
                                        );
                                      }}
                                    />
                                    <label class="labelcard">
                                      <h5 class="basic">{p.productName}</h5>
                                      <h2 class="date_month">
                                        <span class="dates">
                                          {p.currency || "null"}
                                        </span>
                                        {p.amount}
                                        <span class="dates">
                                          Valid from -{" "}
                                          {moment(p.validFrom).format("lll")}
                                        </span>
                                        <span class="dates">
                                          Valid till -
                                          {moment(p.validTill).format("lll")}
                                        </span>
                                      </h2>
                                    </label>
                                  </div>
                                </div>

                                <div class="wrapper col-md-3">
                                  <span
                                    onClick={() => {
                                      setPackTypeId({
                                        ...PackTypeId,
                                        [index]: Math.max(
                                          PackTypeId[index] - 1,
                                          0
                                        ),
                                      });
                                    }}
                                  >
                                    -
                                  </span>
                                  <span class="num">{PackTypeId[index]}</span>
                                  
                                  <span
                                    onClick={() => {
                                      setPackTypeId({
                                        ...PackTypeId,
                                        [index]: PackTypeId[index] + 1,
                                      });
                                    }}
                                    class="plus"
                                  >
                                    +
                                  </span>
                                </div>

                                <div class="text-center">
                                  <button
                                    disabled={getid != p.id}
                                    type="button"
                                    class="btn bg-gradient-primary addbtn"
                                    onClick={() => {
                                      addToCart(index);
                                    }}
                                  >
                                    Add
                                  </button>
                                </div>
                              </>
                            );
                          })}
                      </div> */}
                      <div class="row p-4">
                        {packType?.length > 0 &&
                          packType?.map((p, index) => {
                            console.log({ index });
                            return (
                              <>
                                <div class="col-md-3" key={p.id}>
                                  <div
                                    class="card_234"
                                    key={p.id}
                                    style={{
                                      borderRadius: "18px",
                                    }}
                                  >
                                    <input
                                      required
                                      id="card_33"
                                      type="radio"
                                      name="pricing"
                                      value={p.id}
                                      onChange={(e) => {
                                        console.log(
                                          e.target.checked,
                                          p.id,
                                          index
                                        );
                                        textBoxesChanges(
                                          e.target.checked,
                                          p.id,
                                          index
                                        );
                                      }}
                                    />
                                    <label class="labelcard">
                                      <h5 class="basic">{p.productName}</h5>
                                      <h2 class="date_month">
                                        <span class="dates">₹</span>
                                        {p.amount}
                                        <span class="dates">
                                          /Month
                                          {/* Valid from -{" "} */}
                                          {/* {moment(p.validFrom).format("lll")} */}
                                        </span>
                                        <span class="dates">
                                          {/* Valid till - */}
                                          {/* {moment(p.validTill).format("lll")} */}
                                        </span>
                                      </h2>
                                    </label>
                                    <div class="row justify-content-center mx-0">
                                      <div
                                        class="wrapper col-md-6 m-0 px-0"
                                        style={{
                                          position: "relative",
                                          zIndex: "9",
                                        }}
                                      >
                                        <span
                                          onClick={() => {
                                            setPackTypeId({
                                              ...PackTypeId,
                                              [index]: Math.max(
                                                PackTypeId[index] - 1,
                                                0
                                              ),
                                            });
                                          }}
                                        >
                                          -
                                        </span>
                                        <span class="num">
                                          {PackTypeId[index]}
                                        </span>
                                        <span
                                          onClick={() => {
                                            setPackTypeId({
                                              ...PackTypeId,
                                              [index]: PackTypeId[index] + 1,
                                            });
                                          }}
                                          class="plus"
                                        >
                                          +
                                        </span>
                                      </div>
                                      <div class="text-center mt-2">
                                        <button
                                          disabled={getid != p.id}
                                          type="button"
                                          class="btn bg-gradient-primary addbtn"
                                          style={{
                                            position: "relative",
                                            zIndex: "9",
                                          }}
                                          onClick={() => {
                                            addToCart(index);
                                          }}
                                        >
                                          Add
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                  {/* <div class="row justify-content-center mx-0 mt-3">
                                    <div class="wrapper col-md-6 m-0 px-0">
                                      <span
                                        onClick={() => {
                                          setPackTypeId({
                                            ...PackTypeId,
                                            [index]: Math.max(
                                              PackTypeId[index] - 1,
                                              0
                                            ),
                                          });
                                        }}
                                      >
                                        -
                                      </span>
                                      <span class="num">
                                        {PackTypeId[index]}
                                      </span>
                                      <span
                                        onClick={() => {
                                          setPackTypeId({
                                            ...PackTypeId,
                                            [index]: PackTypeId[index] + 1,
                                          });
                                        }}
                                        class="plus"
                                      >
                                        +
                                      </span>
                                    </div>
                                    <div class="text-center mt-2">
                                      <button
                                        disabled={getid != p.id}
                                        type="button"
                                        class="btn bg-gradient-primary addbtn"
                                        onClick={() => {
                                          addToCart(index);
                                        }}
                                      >
                                        Add
                                      </button>
                                    </div>
                                  </div> */}
                                </div>
                              </>
                            );
                          })}
                      </div>
                    </div>
                    <div
                      class="tab-pane fade "
                      id="SenderMasking"
                      role="tabpanel"
                      aria-labelledby="SenderMasking-tab"
                    >
                      {/* <form>
                        <div class="d-flex align-items-center">
                          <input required="" type="file" accept="xlsx" />
                          <div class="form-check p-0 mx-3">
                            <button
                              type="submit"
                              class="btn bg-gradient-primary uploadcard m-0 "
                             
                            >
                              Upload{" "}
                              <i class="material-icons opacity-10">
                                arrow_right_alt
                              </i>
                            </button>
                          </div>
                          <a
                            target="_blank"
                            download="Reference.xlsx"
                            href="/static/media/Book1.bb490ec85df411b14f17.xlsx"
                          >
                            Download Here
                          </a>
                        </div>
                      </form> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

//[{
//id:'1',
//  qty:"2"
//}]
//{
//   "resellerUserId":130,
//  "packId":6,
//   "quantity":5
//}
//
//
//
//
//
//
//
